import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function DetailCourse() {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("description");
  const [username, setUsername] = useState(null);

  // Extract the courseId from the path
  const courseId = location.pathname.replace("/", "").toLowerCase();

  useEffect(() => {
    console.log("Course ID:", courseId);
    console.log("Active Tab:", activeTab);
    console.log("Course Details:", courseDetails[courseId]);

    if (!courseDetails[courseId]) {
      navigate("/boston"); // Redirect to a default course
    }
    const storedUsername = localStorage.getItem('username');
    if (storedUsername) {
      setUsername(storedUsername);
    }
  }, [courseId, activeTab]);

  const courseDetails = {
    boston: {
      title: "Boston",
      description: (
        <>
		<div style={{ textAlign: "left" }}>
          <p>
            A city with a rich history, world-famous university traditions and
            «visiting cards», does not stop attracting foreign students. Boston,
            located in the heart of the financial district, offers its students
            a dynamic, multinational environment. A two-minute walk to the metro
            opens up the city, where the old streets and lush greenery are
            unusually unique and reveal beautiful pavement, cobblestone and
            unforgettable tourist attractions.
          </p>
          <div className="detail-course__section">
            <h2>Program Length</h2>
            <p>Up to 52 weeks</p>
          </div>
          <div className="detail-course__section">
            <h2>Accommodation options:</h2>
            <ul>
              <li>Family residence</li>
              <li>Student dormitory</li>
            </ul>
          </div>
          <div className="detail-course__section">
            <h2>Details</h2>
            <ul>
              <li>
                Located in the historic Bedford Building, Financial District
              </li>
              <li>Customized design in loft style</li>
              <li>9 audiences</li>
              <li>Large and cosy student lounge area</li>
              <li>Interactive technology</li>
              <li>Free Wi-Fi</li>
              <li>Public transport availability</li>
              <li>Large parking for a fee</li>
              <li>Cafes, restaurants and shops are within walking distance.</li>
            </ul>
          </div>
		  </div>
        </>
      ),
      costs: (
        <>
          <div className="detail-course__table">
            <table>
              <tbody>
                <tr>
                  <th>Course (cost per week)</th>
                  <td>1-4 weeks</td>
                  <td>5-13 weeks</td>
                  <td>14-26 weeks</td>
                  <td>27-39 weeks</td>
                  <td>40-52 weeks</td>
                </tr>
                <tr>
                  <th>
                    General English 16 / 18{" "}
                    <small className="fs-15">
                      (16 or 18 lessons of 50 minutes each)
                    </small>{" "}
                    Specialized English 16 / 18{" "}
                    <small>(16 or 18 lessons of 50 minutes each)</small>
                  </th>
                  <td>$270</td>
                  <td>$245</td>
                  <td>$225</td>
                  <td>$220</td>
                  <td>$215</td>
                </tr>
                <tr>
                  <th>
                    General English 22{" "}
                    <small className="fs-15">(22 lessons of 50 minutes)</small>
                  </th>
                  <td>$385</td>
                  <td>$360</td>
                  <td>$335</td>
                  <td>$330</td>
                  <td>$325</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="detail-course__table">
            <table>
              <tbody>
                <tr>
                  <th rowSpan="2">Individual classes</th>
                  <td>10 classes</td>
                  <td>20 classes</td>
                  <td>50 classes</td>
                  <td>100 classes</td>
                  <td>200 classes</td>
                </tr>
                <tr>
                  <td>$600</td>
                  <td>$1,150</td>
                  <td>$2,700</td>
                  <td>$5,150</td>
                  <td>$9,750</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="detail-course__table">
            <table>
              <tbody>
                <tr>
                  <th colSpan="2">Accommodation (cost per week)</th>
                </tr>
                <tr>
                  <th>Family accommodations, breakfast meals</th>
                  <td>$310</td>
                </tr>
                <tr>
                  <th>Family accommodation, breakfast and dinner</th>
                  <td>
                    $370 <small className="fs-9">($330 if 12+ weeks)</small>
                  </td>
                </tr>
                <tr>
                  <th>Extra night at home</th>
                  <td>$65</td>
                </tr>
                <tr>
                  <th>
                    For students aged 16-17 years, additional payment for family
                    accommodation
                  </th>
                  <td>$25</td>
                </tr>
                <tr>
                  <th>Apartments, hotels</th>
                  <td>on request</td>
                </tr>
              </tbody>
            </table>
            <div className="table-footnote fs-15 right">
              *price includes travel from family to school and back
            </div>
          </div>
          <div className="detail-course__table">
            <table>
              <tbody>
                <tr>
                  <th colSpan="2">Additional payments</th>
                </tr>
                <tr>
                  <th>Enrolment fee</th>
                  <td>$150</td>
                </tr>
                <tr>
                  <th>Accommodation fee</th>
                  <td>$75</td>
                </tr>
                <tr>
                  <th>
                    Host Family Fee (mandatory when booking this type of
                    accommodation)
                  </th>
                  <td>$250</td>
                </tr>
                <tr>
                  <th>Student insurance (per week)</th>
                  <td>$25</td>
                </tr>
                <tr>
                  <th>Transfer from Fort Lauderdale airport (1 way)</th>
                  <td>
                    $155 <small className="fs-9">(additional passenger $35)</small>
                  </td>
                </tr>
                <tr>
                  <th>Status change COS</th>
                  <td>$250</td>
                </tr>
                <tr>
                  <th>Change in the start date</th>
                  <td>$100</td>
                </tr>
                <tr>
                  <th>Training material</th>
                  <td>
                    $43.99 - $89.99{" "}
                    <small className="fs-9">
                      (depending on course chosen)
                    </small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </>
      ),
      photos: [
        "./assets/img/photos/boston/01.jpg",
        "./assets/img/photos/boston/02.jpg",
        "./assets/img/photos/boston/03.jpg",
        "./assets/img/photos/boston/04.jpg",
        "./assets/img/photos/boston/05.jpg",
        "./assets/img/photos/boston/06.jpg",
      ],
      reviews: "Boston course reviews go here...",
    },
    // More course details...
  };

  const course = courseDetails[courseId] || {};

  useEffect(() => {
    console.log("Loaded Course:", course);
  }, [course]);

  const handleTabClick = (tab) => {
    console.log("Tab Clicked:", tab);
    setActiveTab(tab);
  };

  return (
    <section className="detail-course detail-course--tabs">
      {username && <div>Welcome, {username}!</div>}
      <div className="detail-course__container container">
		<img
			className="detail-course__main-photo"
			src={`./assets/img/photos/main/${courseId}.jpg`}
			alt={`${course.title} Main Photo`}
		/>	  
        <h1 className="detail-course__title">{course.title}</h1>
        <ul className="detail-course__tabs">
          <li
            className={`detail-course__tab ${
              activeTab === "description" ? "js-active" : ""
            }`}
            onClick={() => handleTabClick("description")}
          >
            Description
          </li>
          <li
            className={`detail-course__tab mobile-hidden ${
              activeTab === "costs" ? "js-active" : ""
            }`}
            onClick={() => handleTabClick("costs")}
          >
            Courses and Costs
          </li>
          <li
            className={`detail-course__tab mobile-visible ${
              activeTab === "costs" ? "js-active" : ""
            }`}
            onClick={() => handleTabClick("costs")}
          >
            Costs
          </li>
          <li
            className={`detail-course__tab ${
              activeTab === "photos" ? "js-active" : ""
            }`}
            onClick={() => handleTabClick("photos")}
          >
            Photos
          </li>
          <li
            className={`detail-course__tab ${
              activeTab === "reviews" ? "js-active" : ""
            }`}
            onClick={() => handleTabClick("reviews")}
          >
            Reviews
          </li>
        </ul>

        {activeTab === "description" && (
          <div className="detail-course__body">{course.description}</div>
        )}

        {activeTab === "costs" && (
          <div className="detail-course__body">{course.costs}</div>
        )}

        {activeTab === "photos" && (
          <div className="detail-course__body">
            <div className="photos">
              {course.photos &&
                course.photos.map((photo, index) => (
                  <img key={index} src={photo} alt={`Photo ${index + 1}`} />
                ))}
            </div>
          </div>
        )}

        {activeTab === "reviews" && (
          <div className="detail-course__body">
            <h1>Reviews {course.title}</h1>
            <p>{course.reviews}</p>
          </div>
        )}
      </div>
    </section>
  );
}

export default DetailCourse;
